const m = require('minthril');
const { component } = require('../../component');
const { Breadcrumbs } = require('../breadcrumbs');

const SiteNavigation = component(() => ({
  view: ({ attrs: { breadcrumbs, overviewHref, trafficHref, routesHref, costHref, settingsHref, current } }) => m('header.site-navigation', [
    breadcrumbs && m(Breadcrumbs, { items: breadcrumbs }),
    m('nav.site-navigation__pages', [
      overviewHref && m('a', {
        class: current === 'overview' ? 'site-navigation__page--current' : '',
        href: overviewHref
      }, 'Overview'),
      trafficHref && m('a', {
        class: current === 'traffic' ? 'site-navigation__page--current' : '',
        href: trafficHref
      }, 'Traffic'),
      routesHref && m('a', {
        class: current === 'routes' ? 'site-navigation__page--current' : '',
        href: routesHref
      }, 'Routes'),
      costHref && m('a', {
        class: current === 'cost' ? 'site-navigation__page--current' : '',
        href: costHref
      }, 'Cost'),
      settingsHref && m('a', {
        class: current === 'settings' ? 'site-navigation__page--current' : '',
        href: settingsHref
      }, 'Settings')
    ])
  ])
}));

module.exports = { SiteNavigation };
